<div *ngIf="documents">
    <span *ngFor="let document of documents">
        <p>
            {{ document.fileName }}
        </p>
    </span>
    <span *ngIf="documents.length === 0"> No documents found </span>
</div>
